import { Component, Input } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { SparePartsApiService } from 'src/app/api/spareParts/sparePartsApiService';
import { SingleSparePart } from 'src/app/api/spareParts/singleSparePart';

@Component({
    selector: 'spare-part-details',
    templateUrl: './spare-part-details.component.html',
    styleUrls: ['./spare-part-details.component.css'],
    standalone: false
})
export class SparePartDetailsComponent {
  @Input() sparePart: SingleSparePart | undefined = undefined;
  loading: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private location: Location,
    private sparePartApiService: SparePartsApiService) { }

  ngOnInit(): void {
    const idParam = this.route.snapshot.paramMap.get('id');
    const id = idParam as unknown as number;
    if (id == null)
      return;

    this.loading = true;
    this.sparePartApiService.getSparePart(id)
      .subscribe(x => {
        this.sparePart = x;
        this.loading = false;
      });
  }

  back(): void {
    this.location.back()
  }
}
